import { render, staticRenderFns } from "./DetailMesinDanPeralatanPage.vue?vue&type=template&id=946c3fc0"
import script from "./DetailMesinDanPeralatanPage.vue?vue&type=script&lang=js"
export * from "./DetailMesinDanPeralatanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports